<template>
  <div class="tab-calls">
    <v-list class="pa-0">
      <template v-for="(item, index) in filteredItems">
        <v-list-tile
          :key="item.name + index"
          avatar
          ripple
          @click="itemClicked(item)"
          @contextmenu="showMenu(item)"
        >
          <v-list-tile-avatar>
            <user-avatar 
              :avatar="item.avatar"
              :username="item.name" 
              :size="40"
            />
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon :color="item.color">{{ item.icon }}</v-icon>
              <span v-html="getTitle(item)"></span>
            </v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-list-tile-action-text>{{ item.when }}</v-list-tile-action-text>
          </v-list-tile-action>
        </v-list-tile>

        <v-divider
          v-if="index + 1 < filteredItems.length"
          :inset="true"
          :key="index"
        />        
      </template>

    </v-list>

    <v-menu 
      v-model="menuVisible"
      :position-x="x"
      :position-y="y"
      bottom
      offset-y
    >
      <v-list>
        <v-list-tile
          v-for="(item, index) in menuItems"
          :key="index"
          @click="menuItemClicked(item.key)"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<style lang="scss">
  .tab-calls {
    .v-list__tile {
      height: 57px !important; /* same as chat height */
      padding: 6px 16px;
    }
  }
</style>

<script>
  import UserAvatar from '@common/UserAvatar.vue'
  import { EventBus } from '@/event-bus'
  import TimeUtils from '@utils/timeUtils'

  const RecentType = {
    OutgoingCall: 0,
    IncomingCall: 1,
    MissedCall: 2
  }
  const ContextMenuId = {
    context_menu_contact_details: 0,
    context_menu_remove_recent: 1,
    context_menu_block: 2,
    context_menu_clear_history: 3
  }

  export default {
    name: 'tab-calls',
    components: { UserAvatar },
    data () {
      return {
        recents: [],
        blockedContacts: [],
        contextMenuItem: [],
        menuVisible: false,
        menuItems: [
          { key: ContextMenuId.context_menu_contact_details, title: this.$t('contacts_contact_details') },
          { key: ContextMenuId.context_menu_block, title: this.$t('contacts_block') },
          { key: ContextMenuId.context_menu_remove_recent, title: this.$t('recent_calls_delete_entry') },
          { key: ContextMenuId.context_menu_clear_history, title: this.$t('recent_calls_delete_all_recents') }
        ],
        x: 0,
        y: 0,
      }
    },
    props: {
      filter: {
        type: String, 
        default: ''
      },
    },
    computed: {
      filteredItems() {
        let result = []
        if (this.filter !== '') {
          const filter = new RegExp(this.filter, 'i')
          result = this.recents.filter(it => it.name.match(filter))
        } else {
          result = this.recents
        }
        return result
      }
    },
    mounted() { 
      this.fetchRecents()
      this.fetchBlockedContacts()
    },
    methods: {
      fetchRecents() {
        this.$store.dispatch('fetchRecents').then(resp => {
          this.recents = resp.reverse()
          this.recents.map(item => {
            item.when = this.getHumanTime(item.when)

            switch (item.type) {
              case RecentType.OutgoingCall:
                item.icon  = 'call_made'
                item.color = 'green'
                break
              case RecentType.IncomingCall:
                item.icon  = 'call_received'
                item.color = 'blue'
                break
              default: 
                item.icon  = 'call_missed'
                item.color = 'red'
            }
            item.typeIcon = this.typeToIcon(item.type)
          })
        }) 
      },
      fetchBlockedContacts() {
        this.$store.dispatch('fetchBlockedContacts').then(resp => {
          this.blockedContacts = resp
        })
      },
      typeToIcon(type) {
        if (type == RecentType.OutgoingCall)
          return 'call_made'
        else if (type == RecentType.IncomingCall)
          return 'call_received'
        return 'call_missed'
      },
      itemClicked(item) {
        console.log(item)
        this.$store.dispatch('openSingleChat', { contactId:item.contactId }).then(chatId => {
          item.chatId = chatId
        })
      },
      isBlocked(item) {      
        return this.isBlockedId(item.contactId)
      },
      isBlockedId(contactId) {      
        return this.blockedContacts.includes(contactId)
      },
      showMenu (item) {
        if (this.contextMenuIndex != [])
          this.closeContextMenu()
        this.contextMenuItem = item
        this.setBlockUnblockMenu(this.isBlockedId(item.contactId), item.contactId)
        event.preventDefault()

        this.x = event.clientX
        this.y = event.clientY
        this.$nextTick(() => this.menuVisible = true)
      },
      setBlockUnblockMenu(blocked, contactId) {
        let title = blocked? this.$t('contacts_unblock'): this.$t('contacts_block')
        this.$set(this.menuItems, 1, { title: title, key: ContextMenuId.context_menu_block }) 
      },
      menuItemClicked(key) {
        this.closeContextMenu()
        switch (key) {
          case ContextMenuId.context_menu_contact_details:
            this.contactDetails(this.contextMenuItem.contactId)
            break
          case ContextMenuId.context_menu_remove_recent:
            this.removeRecent(this.contextMenuItem)
            break
          case ContextMenuId.context_menu_block:
            if(this.isBlockedId(this.contextMenuItem.contactId))
              this.unblockContact(this.contextMenuItem.contactId)
            else
              this.blockContact(this.contextMenuItem.contactId)
            break
          case ContextMenuId.context_menu_clear_history:
            this.clearHistory()
            break
          default:
            throw new Error('-- unknown key: ' + key)
        }
      },
      contactDetails(contactId) {
        EventBus.$emit('open-contact-profile', contactId)
      },
      removeRecent(item) {
        this.$store.dispatch('removeRecent', item.id).then(resp => this.fetchRecents())
      },
      blockContact(contactId) {
        this.$store.dispatch('blockContact', contactId)
        this.blockedContacts.push(contactId)
        console.log('-- blockContact', this.blockedContacts)
      },
      unblockContact(contactId) {
        this.$store.dispatch('unblockContact', contactId)
        let index = this.blockedContacts.indexOf(contactId)
        if (index > -1)
          this.blockedContacts.splice(index, 1)
        console.log('-- unblockContact', this.blockedContacts)
      },
      clearHistory() {
        this.$store.dispatch('removeAllRecents').then(() => {
          this.recents = []
        })
      },
      markUnreadCalls(callback) {
        this.$store.dispatch('markUnreadRecents').then(() => {
          callback()
        })
      },
      closeContextMenu() {
        let menu = document.getElementById('recentContextMenu' + this.contextMenuIndex)
        if(menu) {
          menu.style.display = 'none'
        }
      },
      contactBlocked(id){
        let index = this.blockedContacts.indexOf(id)
        if (index == -1)
          this.blockedContacts.push(id)
      },
      contactUnblocked(id) {
        let index = this.blockedContacts.indexOf(id)
        if (index !== -1) this.blockedContacts.splice(index, 1)
      },
      getTitle(item) {
        return this.safeTextWithEmoji(item.name)
      }
    },
  }
</script>